var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhyUs1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 45,
    viewBox: "0 0 36 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2754 0.300781H5.02539C2.61258 0.300781 0.650391 2.26297 0.650391 4.67578V16.217V17.8008V44.0508L18.1504 34.0495L35.6504 44.0508V17.8008V16.217V4.67578C35.6504 2.26297 33.6882 0.300781 31.2754 0.300781ZM31.2754 36.5105L18.1504 29.0117L5.02539 36.5105V17.8008V16.217V4.67578H31.2754V16.217V17.8008V36.5105Z",
    fill: "#C10037"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyUs1);
export default __webpack_public_path__ + "static/media/why-us-1.1c0c84cf8f9a66e9bd1a5f7722720cc8.svg";
export { ForwardRef as ReactComponent };